import { AssociatedProgramBO } from 'app/services/career-entry/models/associated-program-list-model';

export class SchoolListRequest {
	countryCode: string;
	schoolCode: string;
	schoolName: string;
	jointVentureCode: string;
	associatedProgramCode: string;
	isActive?: boolean;
	instructorStarsId: string;
}

export class SchoolListResponse {
	content: Array<SchoolBO>;
}

export class SchoolBO {
	schoolCode: string;
	schoolName: string;
	schoolStatus: string;
	jointVentureCode: string;
	jointVentureName: string;
}

export class SchoolListPageState {
	sortColumn: string;
	searchByName: string;
	searchByCode: string;
	sortDirection: string;
	activeStatus: boolean;
	inactiveStatus: boolean;
	appliedFilters = [];
	selectedSchool: SchoolBO;
	associatedProgramList: Array<AssociatedProgramBO>;
	selectedAssociatedProgramIndex: number;
	selectedAssociatedProgram: AssociatedProgramBO;
	selectedSchoolCode: string;
	selectedSchoolName: string;
	selectedSpecialDivisionCode: string;
}


export class SchoolListFilter {
	source: string;
	key: string;
	text: string;
	isReadOnly: false;
}

export class AssociatedProgramItem {
	ceProgramCode: string;
}
